<template>
  <div class="user-menu">
    <!-- Authenticated State -->
    <n-dropdown 
      v-if="isAuthenticated" 
      trigger="hover" 
      :options="menuOptions" 
      @select="handleSelect"
    >
      <n-button text class="user-trigger">
        <div class="flex items-center gap-2">
          <n-avatar round size="small" :src="user?.avatarUrl">
            <template #default>
              <n-icon>
                <UserAvatar />
              </n-icon>
            </template>
          </n-avatar>
          <span class="username">{{ user?.username }}</span>
        </div>
      </n-button>
    </n-dropdown>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { NButton, NAvatar, NDropdown, NIcon } from 'naive-ui';
import { UserAvatar } from '@vicons/carbon';
import { useAuthStore } from '@/stores/auth';
import { storeToRefs } from 'pinia';
import { apiConfig } from '@/services/api/config';

const authStore = useAuthStore();
const { isAuthenticated, user } = storeToRefs(authStore);

// Menu Options
const menuOptions = computed(() => [
  {
    label: '工作台',
    key: 'profile',
  },
  {
    type: 'divider',
    key: 'd1'
  },
  {
    label: '退出登录',
    key: 'logout',
  }
]);

// Handle Selection
async function handleSelect(key: string) {
  if (key === 'profile') {
    // C3: Navigation - Workbench
    window.location.href = apiConfig.externalProfileUrl;
  } else if (key === 'logout') {
    await authStore.logout();
    window.location.href = apiConfig.externalHomeUrl;
  }
}
</script>

<style scoped>
.user-menu {
  display: flex;
  align-items: center;
}
.user-trigger {
  padding: 4px 8px;
}
.username {
  font-weight: 500;
}
</style>

